import { z } from 'zod';
import {
  Orion,
  SupportedChainId,
  VerboseUnitConfig,
  config,
  utils,
} from '@orionprotocol/sdk';

import { envInfoSchema } from './config/schemas/envSchema';

const { chains } = config;
const { isValidChainId } = utils;

export const getOrion = (
  envs: Partial<Record<string, z.infer<typeof envInfoSchema>>>,
  env?: string,
): Orion | undefined => {
  if (env !== undefined) {
    const envConfig = envs[env];
    if (envConfig) {
      const networks = Object.entries(envConfig.networks)
        .map(([chainId, networkConfig]) => {
          if (!isValidChainId(chainId))
            throw new Error(`Invalid chainId: ${chainId}`);
          const chainConfig = chains[chainId];
          if (!chainConfig)
            throw new Error(
              `Chain config not found: ${chainId}. Available chains: ${Object.keys(
                chains,
              ).join(', ')}`,
            );

          return {
            env,
            chainId,
            nodeJsonRpc: networkConfig?.rpc ?? chainConfig.rpc,
            services: {
              blockchainService: {
                http:
                  networkConfig.api + networkConfig.services.blockchain.http,
              },
              aggregator: {
                http:
                  networkConfig.api + networkConfig.services.aggregator.http,
                ws: networkConfig.api + networkConfig.services.aggregator.ws,
              },
              priceFeed: {
                api: networkConfig.api + networkConfig.services.priceFeed.all,
              },
              ...(networkConfig.services.indexer !== undefined && {
                indexer: {
                  api: networkConfig.api + networkConfig.services.indexer.http,
                },
              })
            },
          };
        })
        .reduce<Partial<Record<SupportedChainId, VerboseUnitConfig>>>(
          (acc, cur) => {
            // eslint-disable-next-line no-param-reassign
            acc[cur.chainId] = cur;
            return acc;
          },
          {},
        );

      const unit = new Orion({
        analyticsAPI: envConfig.analyticsAPI,
        referralAPI: envConfig.referralAPI,
        frontageAPI: envConfig.frontageAPI,
        networks,
      });
      return unit;
    }
    return undefined;
  }
  return undefined;
};
